import './style.scss'

export default !function () {
  const block = document.querySelector('.advantages-v1')

  if (!block) {
    return
  }

  const setHeightText = (card, isHide = false) => {
    const textWrapper = card.querySelector('.advantages-v1__desc')

    if (!textWrapper) {
      return
    }

    const text = textWrapper.querySelector('.advantages-v1__desc-text')
    const height = !isHide ? (text?.offsetHeight || 0) : 0

    textWrapper.style.height = `${height}px`
  }

  const openCard = (card) => {
    card.classList.add('advantages-v1__item--active')
    setHeightText(card)
  }

  const closeCard = () => {
    const activeCard = block.querySelector('.advantages-v1__item--active')

    if (!activeCard) {
      return
    }

    activeCard.classList.remove('advantages-v1__item--active')
    setHeightText(activeCard, true)
  }

  const setInitValues = () => {
    const cards = block.querySelectorAll('.advantages-v1__item')

    cards.forEach((card, index) => {
      index === 0
        ? openCard(card)
        : setHeightText(card, true)
    })
  }

  setInitValues()

  block.addEventListener('click', (evt) => {
    evt.preventDefault()

    const card = evt.target.closest('.advantages-v1__item')

    if (!card || card.classList.contains('advantages-v1__item--active')) {
      return
    }

    closeCard()
    openCard(card)
  })

  block.addEventListener('keydown', (evt) => {
    if (evt.key !== 'Enter') {
      return
    }

    const card = evt.target.closest('.advantages-v1__item')

    if (!card || card.classList.contains('advantages-v1__item--active')) {
      return
    }

    closeCard()
    openCard(card)
  })

  let ticking = false

  window.addEventListener('resize', () => {
    if (!ticking) {
      requestAnimationFrame(() => {
        const activeAdvantage = block.querySelector('.advantages-v1__item--active')

        if (activeAdvantage) {
          setHeightText(activeAdvantage)
        }

        ticking = false
      })
      ticking = true
    }
  })
}()
